import { useMemo } from "react";

import { getStateInfoFromAvailability } from "@faire/retailer/features/Exclusivity/getStateInfoFromAvailability";

import {
  useExclusivityAvailability,
  Options,
} from "./useExclusivityAvailability";

/**
 * See useExclusivityAvailability.ts for more details on Options.
 */
export const useExclusivityAvailabilityWithState = (
  brandToken?: string,
  options?: Options
) => {
  const { availability, ...rest } = useExclusivityAvailability(
    brandToken,
    options
  );
  const state = useMemo(
    () => getStateInfoFromAvailability(availability),
    [availability]
  );

  return { availability, state, ...rest };
};
